import React, { useState } from "react";
import { FiEdit2 } from "react-icons/fi";
import EditCampaignModal from "../modals/EditCampaignModal";

const CampaignItem = ({ campaign, isSelected, children, onSelect }) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const handleEditClick = (e) => {
    e.stopPropagation(); // Prevent triggering the campaign selection
    setIsEditModalOpen(true);
  };

  const handleCampaignClick = () => {
    if (onSelect) {
      onSelect(campaign.id);
    }
  };

  return (
    <div className="flex flex-col">
      <div className="flex justify-between items-center">
        <div
          onClick={handleCampaignClick}
          className={`flex-grow p-3 border border-gray-300 rounded-lg ${isSelected ? 'bg-sky-100' : 'bg-white'} text-black cursor-pointer hover:bg-sky-50 transition-colors`}>
          <h3 className="font-semibold text-sky-900 mb-2">{campaign.title}</h3>
        </div>
        <FiEdit2
          className="text-gray-500 hover:text-gray-700 cursor-pointer ml-2 flex-none"
          onClick={handleEditClick}
        />
      </div>
      {/* Always render children, regardless of selection state */}
      {children}
      <EditCampaignModal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        campaign={campaign}
      />
    </div>
  );
};

export default CampaignItem;
